import { Icon } from '../components/Icon';
import { CAMPAIGN_EXAMPLES } from '../content/site';

export function CampaignExamples() {
  return (
    <section id="examples" className="section bg-white">
      <div className="container-content">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">Campaign examples</span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-ink-900 sm:text-4xl">
            What a sponsored campaign looks like
          </h2>
          <p className="mt-4 text-lg text-ink-500">
            Two worked examples — a dealership foot-traffic campaign and a retail voucher campaign.
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-2">
          {CAMPAIGN_EXAMPLES.map((example) => (
            <article
              key={example.id}
              className="group flex flex-col overflow-hidden rounded-3xl border border-line bg-white shadow-card"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-aurora-soft">
                <img
                  src={example.image}
                  alt={`${example.name} — campaign illustration`}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-300 motion-safe:group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 eyebrow bg-white/85 backdrop-blur">{example.badge}</span>
              </div>
              <div className="relative bg-aurora-soft p-6 sm:p-8">
                <div className="flex items-start gap-4">
                  <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-aurora text-white">
                    <Icon name={example.icon} className="h-7 w-7" />
                  </span>
                  <div>
                    <h3 className="font-heading text-xl font-bold text-ink-900">{example.name}</h3>
                    <p className="mt-1 text-sm text-ink-500">
                      {example.partner} &middot; {example.prize}
                    </p>
                  </div>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-ink-700">{example.summary}</p>
              </div>

              <div className="flex flex-1 flex-col p-6 sm:p-8">
                <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-primary-700">
                  How it runs
                </h4>
                <ol className="mt-3 space-y-2">
                  {example.flow.map((step, i) => (
                    <li key={i} className="flex gap-3 text-sm text-ink-700">
                      <span className="grid h-5 w-5 shrink-0 place-items-center rounded-full bg-primary-100 font-heading text-xs font-bold text-primary-700">
                        {i + 1}
                      </span>
                      <span>{step}</span>
                    </li>
                  ))}
                </ol>

                <div className="mt-6 flex flex-wrap gap-2 border-t border-line pt-5">
                  {example.benefits.map((b) => (
                    <span
                      key={b}
                      className="inline-flex items-center gap-1.5 rounded-full bg-surface-muted px-3 py-1 text-xs font-medium text-ink-700"
                    >
                      <Icon name="check" className="h-3.5 w-3.5 text-primary-600" />
                      {b}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CampaignExamples;
